'use client'

import { PageEventProps, useDispatchPageEvent } from '@/global/hooks'

/**
 * Dispara o evento de page view a partir de um Server Component.
 * O hook precisa de efeito e de `document`, entao mora aqui, num componente
 * cliente que nao renderiza nada.
 */
export const PageViewEvent = (props: PageEventProps) => {
  useDispatchPageEvent(props)

  return null
}
